export const SIGNUP_TYPE_GOOGLE = 'google_sso';
export const SIGNUP_TYPE_FACEBOOK = 'facebook';
export const SIGNUP_TYPE_MICROSOFT = 'microsoft';
export const SIGNUP_TYPE_EMAIL = 'email';
